import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useQuestions } from './hooks/useQuestions';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { serviceMonitorQuestionHeader } from "constants/serviceDetails";
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  questionFilter: {
    '& .dropdown-content': {
      minWidth: '650px'
    }
  }
}));

export const QuestionFilter = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { filterValues, updateFilter, config, isShowAll } = useFilters();
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const showAllOption = isShowAll('question');

  const modelVersionId = filterValues.model?.value?.activeModelVersionID;
  const roleId = filterValues.role?.params?.roleId;
  const intervalId = filterValues.interval?.params?.intervalId;
  const questions = useQuestions(modelVersionId, roleId, intervalId, showAllOption);

  // Use useFilterInitialization for consistent initialization and dependency management
  useFilterInitialization('question', questions, {
    getDefaultValue: () => ({}), // Don't set any default selection for question filter
    getParams: (item) => ({
      questionId: item.id || '',
      modelVersionTaskQuestionId: item.modelVersionTaskQuestionID || '',
      modelVersionZoneId: item.modelVersionZoneID || '',
      modelVersionStageId: item.modelVersionStageID || ''
    }),
    dependencies: [modelVersionId, roleId, intervalId],
    resetOnDependencyChange: true, // Reset question when model, role, or interval changes
    waitForData: true
  });

  const handleQuestionChange = (item) => {
    // Ensure we're passing the correct structure with additional IDs
    updateFilter('question', item, { 
      questionId: item.id || '',
      modelVersionTaskQuestionId: item.modelVersionTaskQuestionID || '',
      modelVersionZoneId: item.modelVersionZoneID || '',
      modelVersionStageId: item.modelVersionStageID || ''
    });
  };

  return (
    <Grid item lg={3} md={6} xs={12} className={classes.questionFilter}>
      <DyanamicDropdown
        dropDownActiveWidth="auto"
        dataSource={questions}
        dataHeader={serviceMonitorQuestionHeader(customCaptions, "A")}
        showHeader
        columns={[
          { id: 1, name: "stageName" },
          { id: 2, name: "zoneName" },
          { id: 3, name: "taskName" },
          { id: 4, name: "questionName" },
          { id: 5, name: "arrangementName" }
        ]}
        columnsMinWidths={[160, 160, 160, 160, 160]}
        placeholder={t("placeholder.selectEntity", { entity: customCaptions?.question })}
        width="100%"
        onChange={handleQuestionChange}
        selectdValueToshow="questionName"
        selectedValue={filterValues.question?.value}
        label={t("label.filterByEntity", { entity: customCaptions?.question })}
        isServerSide={false}
        icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
        required={config.filters.question?.required}
        showBorderColor
      />
    </Grid>
  );
};
